// @ts-nocheck

import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import { FreebetsIcon } from '../../../../assets/img/betting';
import Primary from '../../../../components/PrimaryButton';
import SpinePlayer from '../../../../components/SpinePlayer';
import Formatter from '../../../../i18n/formatter';
import { __, getCurrency } from '../../../../i18n/l10n';
import theme from '../../../../styled-components/dark';
import { GeneralSpineAnimationsIds } from '../../../../types/animations';
import { SoundIds } from '../../../../types/sounds';
import { type BoomNotificationState } from '../../types/notification';
import BoomViewWrapper from '../BoomViewWrapper';
import BoomBoxWrapper from '../common/BoomBoxWrapper';

const APPEARANCE_ANIMATION_DURATION = 1000;
const APPEARANCE_ANIMATION_DELAY = 500;

const StyledBoomViewWrapper = styled(BoomViewWrapper)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
`;

const Buttons = styled.div`
  margin-top: auto;
  display: flex;
  position: relative;
  z-index: 2;

  & > button {
    flex-grow: 1;
    flex-basis: 0;

    &:last-child:not(:first-child) {
      margin-left: 1em;
    }
  }
`;

const commonButton = css`
  font-size: 1em;
  min-height: 2.6em;
`;

const ClaimButton = styled(Primary)`
  ${commonButton};
  color: ${theme.BasketCtas.primary.color};
  background-color: ${theme.BasketCtas.primary.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125em;
`;

const FreebetIcon = styled.img`
  width: 1.375em;
  height: 1.375em;
  display: inline-block;
  margin-left: 0.1em;
`;

const fadeInWithTranslationAnim = keyframes`
  0% {
    transform: translate(-50%, 25%);
    opacity: 0;
  }

  50% {
    transform: translate(-50%, 25%);
    opacity: 0;
  }

  100% {
    transform: translate(-50%, 0);
    opacity: 1;
  }
`;

const StyledBoomBoxWrapper = styled(BoomBoxWrapper)`
  padding: 0.3em 1.3em 0.5em;
  align-items: center;
  display: inline-block;
`;

const Infos = styled.div`
  color: #fff;
  font-weight: bold;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 60%;
  opacity: 0;

  animation: ${fadeInWithTranslationAnim} ${APPEARANCE_ANIMATION_DURATION}ms ease-in-out forwards;
  animation-delay: ${APPEARANCE_ANIMATION_DELAY}ms;
`;

const InfosLabel = styled.div`
  font-family: 'ChangaOne', sans-serif;
  font-size: 1.7em;
  margin-bottom: 0.6em;
  white-space: nowrap;
`;

const InfosAmount = styled.div`
  font-size: 2.6em;
`;

type BoomNotificationProps = {
  className?: string;
  notification: BoomNotificationState;
  onClaimReward: () => void;
};

const BoomNotification = ({ className = '', notification, onClaimReward }: BoomNotificationProps) => {
  return (
    <StyledBoomViewWrapper className={className} noScroll>
      <SpinePlayer
        animationId={GeneralSpineAnimationsIds.WIN_FREEBETS}
        scale={0.5}
        soundId={SoundIds.GLOBAL_FREEBETS}
        hideMuteButton
      />
      {notification?.data?.amount ? (
        <Infos>
          <InfosLabel>{__('You won Freebets')}</InfosLabel>
          <StyledBoomBoxWrapper>
            <InfosAmount>{Formatter.formatNumber(notification.data.amount, getCurrency())}</InfosAmount>
          </StyledBoomBoxWrapper>
        </Infos>
      ) : null}

      <Buttons>
        <ClaimButton onClick={onClaimReward}>
          {__('Claim')}
          <FreebetIcon src={FreebetsIcon} alt="freebet icon" />
        </ClaimButton>
      </Buttons>
    </StyledBoomViewWrapper>
  );
};

export default BoomNotification;
